export default {
    preloaded: ({app}) => app.preloaded,
    loaded: ({app}) => app.loaded,
    notify: ({app}) => app.notify,
    language: ({app}) => app.language,
    sounds: ({app}) => app.sounds,
    jackpots: ({app}) => app.jackpots,
    jackpots_loaded: ({app}) => app.jackpots !== null
}